@for (product of products; track $index) {
<app-product-list-item [data]="product" showdown [showDelay]="min($index*80,640)"></app-product-list-item>
}